/**
 * テキスト正規化ユーティリティ
 * キャラクター名や日本語テキストの正規化処理を提供
 */

/**
 * カタカナをひらがなに変換する
 *
 * @param text カタカナテキスト
 * @returns ひらがなテキスト
 */
const katakanaToHiragana = (text: string): string => {
  return text.replace(/[\u30A1-\u30F6]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0x60));
};

/**
 * ひらがなをカタカナに変換する
 *
 * @param text ひらがなテキスト
 * @returns カタカナテキスト
 */
export const hiraganaToKatakana = (text: string): string =>
  text.replace(/[\u3041-\u3096\u309D-\u309F]/g, (c) => String.fromCharCode(c.charCodeAt(0) + 0x60));

/**
 * 文字列からルビ振りを除去する
 * 「デモ君（くん）」→「デモくん」の形式
 *
 * @param text ルビ振りを含む可能性のあるテキスト
 * @returns ルビ振りが除去されたテキスト
 */
export const removeRuby = (text: string): string => {
  // ひらがな＋漢字＋ふりがな（「でも君（くん）」）
  let m = text.match(/^([ぁ-ん]+)(.+?)[（(]([^）)]+)[）)]/);
  if (m) {
    return m[1] + m[3];
  }

  // カタカナ(1文字以上)＋漢字＋ふりがな（「デモ君（くん）」）
  m = text.match(/^([ァ-ンヴー]+)(.+?)[（(]([^）)]+)[）)]/);
  if (m) return m[1] + m[3];

  // 漢字＋ふりがな（「東京（とうきょう）」）
  m = text.match(/^(.+?)[（(]([^）)]+)[）)]/);
  if (m) return m[2];

  // カタカナのみ
  m = text.match(/^([ァ-ンヴー]+)$/);
  if (m) return katakanaToHiragana(m[1]);

  // それ以外はそのまま
  return text;
};

/**
 * キャラクター名を正規化する
 * ルビ振りを削除し、ひらがなをカタカナに統一、スペースを削除
 *
 * @param text 正規化対象のテキスト
 * @returns 正規化されたテキスト
 */
export const normalizeCharacterName = (text: string): string => {
  const withoutRuby = removeRuby(text);
  const withoutSpace = withoutRuby.replace(/\s+/g, "");
  return hiraganaToKatakana(withoutSpace);
};
